var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c("vs-input", {
          staticClass: "w-100",
          attrs: { readonly: "", label: "Ingreso" },
          model: {
            value: _vm.number,
            callback: function($$v) {
              _vm.number = $$v
            },
            expression: "number"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c("vs-input", {
          staticClass: "w-100",
          attrs: { readonly: "", label: "Fecha" },
          model: {
            value: _vm.loaded.date,
            callback: function($$v) {
              _vm.$set(_vm.loaded, "date", $$v)
            },
            expression: "loaded.date"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c("vs-input", {
          staticClass: "w-100",
          attrs: { readonly: "", label: "Expediente" },
          model: {
            value: _vm.loaded.expedient,
            callback: function($$v) {
              _vm.$set(_vm.loaded, "expedient", $$v)
            },
            expression: "loaded.expedient"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c("vs-input", {
          staticClass: "w-100",
          attrs: { readonly: "", label: "Remitente" },
          model: {
            value: _vm.loaded.sender,
            callback: function($$v) {
              _vm.$set(_vm.loaded, "sender", $$v)
            },
            expression: "loaded.sender"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c("vs-input", {
          staticClass: "w-100",
          attrs: { readonly: "", label: "Tipo de documento" },
          model: {
            value: _vm.loaded.docType,
            callback: function($$v) {
              _vm.$set(_vm.loaded, "docType", $$v)
            },
            expression: "loaded.docType"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c("vs-input", {
          staticClass: "w-100",
          attrs: { readonly: "", label: "Formato de ingreso" },
          model: {
            value: _vm.loaded.inputFormat,
            callback: function($$v) {
              _vm.$set(_vm.loaded, "inputFormat", $$v)
            },
            expression: "loaded.inputFormat"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("b-table", {
          attrs: {
            fields: _vm.fields,
            items: _vm.loaded.attachments,
            "empty-text": "Sin archivos",
            caption: "Adjuntos",
            "caption-top": "",
            "show-empty": "",
            striped: ""
          },
          scopedSlots: _vm._u([
            {
              key: "cell(watch)",
              fn: function(ref) {
                var item = ref.item
                return [
                  item && item.name && item.watch
                    ? _c("DownloadFile", {
                        staticClass: "pill-info-attach",
                        attrs: {
                          mood: "compact",
                          path: item.watch,
                          name: item.name
                        }
                      })
                    : _vm._e()
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }